import actions from './actions';

const initState = {
  isCreating: false,
  isSearching: false,
  isUpdating: false,
  isLoading: false,
};

export default function reducer(state = initState, action) {
  switch (action.type) {
    case actions.CREATE_THIRD_PARTY_ORDER:
      return {
        ...state,
        isCreating: true,
      };
    case actions.CREATE_THIRD_PARTY_ORDER_ENDED:
      return {
        ...state,
        isCreating: false,
      };
    case actions.GET_THIRD_PARTY_ORDER:
    case actions.GET_THIRD_PARTY_ORDER_TRANSACTIONS:
      return {
        ...state,
        isSearching: true,
      };
    case actions.REFUND_THIRD_PARTY_ORDER:
      return {
        ...state,
        isLoading: true,
      };
    case actions.REFUND_THIRD_PARTY_ORDER_ENDED:
      return {
        ...state,
        isLoading: false,
      };
    case actions.GET_THIRD_PARTY_ORDER_ENDED:
    case actions.GET_THIRD_PARTY_ORDER_TRANSACTIONS_ENDED:
      return {
        ...state,
        isSearching: false,
      };
    default:
      return state;
  }
}
